import { onboardingSteps } from "@/mocks/homepageData";
import { useScrollReveal, getRevealClasses } from "@/hooks/useScrollReveal";

export default function OnboardingSection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal(0.1);

  return (
    <section ref={sectionRef} className={`py-20 md:py-28 bg-[#0B0F19] ${getRevealClasses(sectionVisible, "up")}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#7C3AED]/40 mb-6">
            <i className="ri-route-line text-[#7C3AED]"></i>
            <span className="text-sm text-[#F8FAFC]">Getting Started</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F8FAFC] mb-4">
            Start Trading in{" "}
            <span className="text-gradient">3 Simple Steps</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            From registration to your first trade — get started in under 30 minutes.
          </p>
        </div>

        {/* Desktop Horizontal Timeline */}
        <div className="hidden md:block">
          <div className="relative">
            {/* Connecting Line */}
            <div className="absolute top-[60px] left-[16%] right-[16%] h-0.5 bg-[#374151]">
              <div className="absolute inset-0 bg-gradient-to-r from-[#7C3AED] via-[#7C3AED] to-[#10B981]"></div>
            </div>

            <div className="grid grid-cols-3 gap-8">
              {onboardingSteps.map((step) => (
                <div key={step.step} className="relative text-center">
                  {/* Step Number */}
                  <div className="relative z-10 w-[120px] h-[120px] mx-auto mb-6">
                    <div className="w-full h-full rounded-full bg-[#1F2937] border-2 border-[#7C3AED] flex flex-col items-center justify-center">
                      <i className={`${step.icon} text-2xl text-[#7C3AED] mb-1`}></i>
                      <span className="text-2xl font-bold text-[#F8FAFC]">0{step.step}</span>
                    </div>
                  </div>

                  {/* Duration badge */}
                  <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#10B981]/15 text-[#10B981] text-xs font-medium mb-3">
                    <i className="ri-time-line"></i>
                    {step.duration}
                  </div>

                  <h3 className="text-lg font-bold text-[#F8FAFC] mb-2">{step.title}</h3>
                  <p className="text-sm text-[#94A3B8] leading-relaxed max-w-xs mx-auto">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile Vertical Timeline */}
        <div className="md:hidden space-y-8">
          {onboardingSteps.map((step, index) => (
            <div key={step.step} className="relative flex gap-5">
              {/* Vertical line */}
              {index < onboardingSteps.length - 1 && (
                <div className="absolute left-[22px] top-14 bottom-[-20px] w-0.5 bg-[#374151]"></div>
              )}

              {/* Icon circle */}
              <div className="relative z-10 w-11 h-11 rounded-full bg-[#1F2937] border-2 border-[#7C3AED] flex items-center justify-center flex-shrink-0">
                <span className="text-sm font-bold text-[#F8FAFC]">0{step.step}</span>
              </div>

              {/* Content */}
              <div className="flex-1 pt-1">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#10B981]/15 text-[#10B981] text-xs font-medium mb-2">
                  <i className="ri-time-line"></i>
                  {step.duration}
                </div>
                <h3 className="text-base font-bold text-[#F8FAFC] mb-1">{step.title}</h3>
                <p className="text-sm text-[#94A3B8] leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}